import { useState, useMemo, Children } from "react";
import PropTypes from "prop-types";
import clientConfig from "@template/clientConfig";

const SSRHydrationWrapper = ({ children, isNavApiLoaded }) => {
  const isServer = clientConfig.isServer();
  const isPreviewHarness = clientConfig.isPreviewHarness();

  const child = Children.only(children);
  const id = child.props["id"];

  const [ssrHtml] = useState(() => {
    if (isServer || !id) {
      return "";
    }

    const ssrElement = document.querySelector(`[id="${id}"]`);

    return ssrElement?.outerHTML ?? "";
  });

  const ssrContent = useMemo(
    () => <div dangerouslySetInnerHTML={{ __html: ssrHtml }} />,
    [ssrHtml]
  );

  if (!isServer && !isNavApiLoaded && !isPreviewHarness) {
    return ssrContent;
  }

  // Extra div element is necessary to match the SSR structure, as
  // `dangerouslySetInnerHTML` cannot be used on the child directly.
  return <div>{children}</div>;
};

SSRHydrationWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  isNavApiLoaded: PropTypes.bool.isRequired
};

export default SSRHydrationWrapper;
